<template>
  <div class="assignment">
    <div class="ass-head">
      <i class="iconfont icon-back" @click="back" title="返回作业列表"></i>
    </div>
    <div style="height: calc(100% - 4.4rem);overflow: auto;">
      <InjectEditorPracticeJS @injectJSFinish="injectJSFinish"></InjectEditorPracticeJS>
      <div class="ass-con">
        <acoj-render
            ref="acoj"
            v-if="injectJSLoadFinish"
            :problem-info="problemInfo"
            :user-result="userResult"
            :user-result-record="userResultRecord"
            @commitResult="commitResult"
            @loadUserResultRecord="loadUserResultRecord"
        />
      </div>
      <div class="ass-foot">
        <div class="topic-change topic-last" @click="changeSubject('pre')">上一题
        </div>
        <div v-if="from === 0" class="topic-change topic-last" @click="changeSubject('random')">随机一题
        </div>
        <div class="topic-change topic-next"
             @click="changeSubject('next')">下一题
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { problemInfo, userResult, submitAnswer, userResultRecord } from '@/api/xinAoTraining'
import acojRender from "@/components/acojRender";

import InjectEditorPracticeJS from "@/components/InjectEditorPracticeJSV2";
export default {
  name: "ProblemInfo",
  components: {
    acojRender,
    InjectEditorPracticeJS
  },
  data() {
    return {
      problemId: null,
      from: 0,
      activeNum: 0, // 当前第几个作业
      problemInfo: null, // 题目详情
      userResult: null, // 作业结果
      userResultRecord: null, // 作业结果记录
      resultTime: 0, // 提交后获取作业次数
      injectJSLoadFinish: false,
      baseLoading: null,
      changeLoading: false
    }
  },
  watch: {
    problemId() {
      this.loadProblemInfo()
    }
  },
  created() {
    this.problemId = this.$route.query.problemId;
    if(this.$route.query.from) {
      this.from = this.$route.query.from;
    }
  },
  mounted() {
    this.loadProblemInfo();
  },
  methods: {
    back() {
      this.$router.push({
        name: "xinAoTraining"
      })
    },
    // 初始化编程星球
    injectJSFinish: function(val) {
      this.injectJSLoadFinish = val
    },
    loadProblemInfo() { // 获取题目详情
      this.baseLoading = this.$loading({
        text: "题目加载中...",
        spinner: 'el-icon-loading',
        background: "rgba(0, 0, 0, 0.3)"
      });
      problemInfo({ problemId: this.problemId, from: this.from }).then(res => {
        this.problemInfo = res.data.problemInfo
        this.baseLoading = false
      })
    },
    async homeworkResult(resultId) { // 获取题目结果
      let res = await userResult({
        solutionId: resultId
      })
      console.log("作业结果", new Date().getTime(), JSON.parse(JSON.stringify(res.data)));
      if (res.data.status === 2) {
        if (this.baseLoading) this.baseLoading.close();
        this.userResult = res.data;
      } else {
        setTimeout(_ => {
          if (this.resultTime > 120) {
            if (this.baseLoading) this.baseLoading.close();
            this.$message.error("运行失败！");
          } else {
            this.homeworkResult(resultId);
            this.resultTime++;
          }
        }, 4000);
      }
    },
    async commitResult({ codeContent, language }) { // 提交作业
      const data = {
        problemId: this.problemId,
        codeContent: codeContent,
        language: language
      }
      console.log(data, '***************代码测试')

      let res = await submitAnswer(data);
      // console.log("提交作业", res);
      if (res.status === 1) {
        this.baseLoading = this.$loading({
          text: "正在运行代码...",
          spinner: 'el-icon-loading',
          background: "rgba(0, 0, 0, 0.3)"
        });
        setTimeout(_ => {
          this.resultTime = 0;
          this.homeworkResult(res.data.rid);
        }, 4000)
      } else {
        this.$message.error(res.message);
      }
    },
    loadUserResultRecord(callback) {
      userResultRecord({ problemId: this.problemId }).then(res => {
        this.userResultRecord = res.data.userResultRecord
        callback()
      })
    },
    changeSubject(index) { // 切换题目
      let problemId = null
      if (index === 'pre') {
        problemId = this.problemInfo.pre_problem_id
      } else if (index === 'next') {
        problemId = this.problemInfo.next_problem_id
      } else if (index === 'random') {
        problemId = this.problemInfo.random_problem_id
      } else if (index === 'same_type') {
        problemId = this.problemInfo.same_type_problem_id
      }
      if (!problemId) {
        this.$message({
          type: 'info',
          message: '没有题目了'
        })
        return false
      }
      this.problemId = problemId
      this.userResult = null
      this.userResultRecord = null
      this.$refs.acoj.activeName = 'challenge_description'
      this.$refs.acoj.resetEditor()
    }
  }
}
</script>

<style lang="scss" scoped>
.assignment {
  width: 100%;
  height: 100%;
  position: relative;
  background: url(~@/assets/img/mainBg.png) no-repeat;
  background-size: 100% 100%;

  .ass-head {
    height: 3.8rem;
    background-color: #252629;
    border-bottom: 0.4rem solid #203B4D;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1.6rem;

    .icon-back {
      font-size: 1.68rem;
      cursor: pointer;
      color: #FFF;
      margin-left: 0.4rem;
    }

    .topic-num {
      //width: 100%;
      //height: 80px;
      //white-space: nowrap;
      //overflow-x: scroll;
      //line-height: 70px;
      li {
        display: inline-block;
        width: 1.6rem;
        height: 1.6rem;
        text-align: center;
        line-height: 1.6rem;
        color: #FFF;
        font-size: 0.72rem;
        background-color: #748C9A;
        border-radius: 50%;
        margin-left: 0.6rem;
        cursor: pointer;
        user-select: none;
      }

      li.active {
        background-color: #35EAFF;
      }

      li.succeed {
        background-color: #67c23a;
      }

      li.error {
        background-color: #F56C6C;
      }
    }
  }

  .ass-con {
    min-height: 12rem;
    padding: 0.8rem;
    height: calc(100% - 5.44rem);
  }

  .ass-foot {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 0.8rem;
    margin-top: 0.6rem;
    width: 50%;
    .topic-change {
      width: 6.5rem;
      height: 2rem;
      background: url(~@/assets/img/problemBackground.png) no-repeat;
      text-align: center;
      color: #FFF;
      cursor: pointer;
      background-size: 100%;
      margin: 0 2.2rem;
      user-select: none;
      font-size: 0.9rem;
      line-height: 1.6rem;
    }

    .topic-last {}

    .topic-next {}
  }
}
</style>
